<template>
  <div class="layout w-full">
    <div v-if="txLoading">
      <section class="section">
        <table class="table">
          <tbody>
            <tr>
              <td data-label="Hash" class="hash tt-capitalize">
                <div class="anim"></div>
              </td>
            </tr>
            <tr>
              <td data-label="Data" class="hash">
                <div class="anim"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
    <div v-else-if="searchResultData">
      <div v-for="(item, index) in searchResultData.results" :key="item.hash">
        <section class="section">
          <h2 class="tt-capitalize ta-left">
            <span v-if="searchResultData.results.length > 1">
              {{ index + 1 }}.
            </span>
            <span>{{ item.type }} details</span>
          </h2>
          <table class="table">
            <tbody>
              <tr>
                <td
                  :data-label="`${item.type} Hash`"
                  class="hash tt-capitalize"
                >
                  <div class="hash__item">
                    <input
                      ref="clone"
                      readonly
                      :value="$route.params.hash"
                      @focus="$event.target.select()"
                    />
                    <button ref="btnToggle" class="button--gray" @click="copy">
                      <span>copy</span>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="item" class="raw-data-string">
                <td data-label="Data">
                  <div class="raw-data-section">
                    <div class="raw-data-container">
                      <div
                        class="raw-data-wrapper"
                        :class="{
                          'raw-data-wrapper--ellipsis': !expandedItems[index],
                          'raw-data-wrapper--unfolded': expandedItems[index],
                        }"
                      >
                        <div
                          class="raw-json-wrapper"
                          :class="{
                            'raw-json-wrapper--unfolded': expandedItems[index],
                          }"
                        >
                          <button
                            :ref="`jsonCopyBtn-${index}`"
                            class="json-copy-btn"
                            @click="copyJSON(item, index)"
                          >
                            copy
                          </button>
                          <pre
                            class="raw-json"
                            :class="{
                              'raw-json--unfolded': expandedItems[index],
                            }"
                            >{{ JSON.stringify(item, null, 2) }}</pre
                          >
                        </div>
                      </div>
                      <button
                        class="button button--gray button--show-more w-full"
                        @click="toggleExpanded(index)"
                      >
                        {{ expandedItems[index] ? "Collapse" : "Expand" }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
    <div v-else>
      <div class="layout w-full ta-center">
        <h2>No data found</h2>
      </div>
    </div>
    <Hint v-model:show="hintVisible">
      <p>{{ hintText }}</p>
    </Hint>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { globalMethodsMixin } from "@/mixins/globalMethodsMixin";

export default {
  mixins: [globalMethodsMixin],
  data() {
    return {
      hintVisible: false,
      hintText: "Error",

      txItem: "",

      inputTxValue: "",

      txLoading: false,

      text: "This will get copied!",

      expandedItems: {},

      searchResultData: null,

      rawData: null,
      responseError: null,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],

      txUrl: "",
      unifiedEndpoint: "https://1.api.explorer.cellframe.net/expl",

      dialogBalanceVisible: false,
      balanceLoading: false,
      inputBalanceValue: "",
      Balance: [],
    };
  },
  props: {
    size: {
      type: Number,
      required: false,
      default: 100,
    },
  },

  _methods: {
    toggleExpanded(index) {
      this.expandedItems[index] = !this.expandedItems[index];
    },

    async searchTxItem(hash) {
      this.txLoading = true;
      try {
        // Добавляем задержку с Promise вместо setTimeout
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const response = await axios.get(
          `https://2.api.explorer.cellframe.net/search/${hash}`,
          {
            // Настраиваем axios для выброса ошибок при 4xx и 5xx статусах
            validateStatus: function (status) {
              return status >= 200 && status < 300; // Только 2xx статусы считаются успешными
            },
          }
        );

        console.log(response.data);

        this.searchResultData = response.data;
      } catch (error) {
        if (error.response) {
          this.hintText = `HTTP Error ${error.response.status}: ${error.response.statusText}`;
        } else if (error.request) {
          // Запрос был отправлен, но ответа не получено
          this.hintText = "Network error: No response received";
        } else {
          // Ошибка при настройке запроса
          this.hintText = error.msg || "An error occurred";
        }

        this.showHint();
      }
      this.txLoading = false;
    },

    copy() {
      this.$refs.btnToggle.innerText = "copy";
      this.$refs.clone.focus();
      document.execCommand("copy");
      this.$refs.btnToggle.innerText = "done";
      setTimeout(async () => {
        this.$refs.btnToggle.innerText = "copy";
      }, 800);
    },

    copyJSON(item, index) {
      const jsonString = JSON.stringify(item, null, 2);
      const refName = `jsonCopyBtn-${index}`;

      // Создаем временный элемент для копирования
      const tempElement = document.createElement("textarea");
      tempElement.value = jsonString;
      document.body.appendChild(tempElement);
      tempElement.select();
      document.execCommand("copy");
      document.body.removeChild(tempElement);

      // Обновляем текст кнопки
      const button = this.$refs[refName];
      if (button && button[0]) {
        button[0].querySelector("span").innerText = "copied";
        setTimeout(() => {
          button[0].querySelector("span").innerText = "copy";
        }, 800);
      }
    },
    showHint() {
      this.hintVisible = true;

      setTimeout(() => {
        this.hintVisible = false;
      }, 2000);
    },
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },

  mounted() {
    this.searchTxItem(this.$route.params.hash);
  },

  watch: {},
};
</script>

<style scoped>
@import "../assets/css/layout.css";
@import "../assets/css/pagination.css";
@import "../assets/css/index.css";

.layout {
  margin: 48px 0 0;
  padding: 0 16px 48px;
}

.section {
  max-width: 1080px;
  width: 100%;
  overflow-x: hidden;
}

.table {
  width: 100%;
  table-layout: fixed;
}

.section--option {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.hash__item {
  position: relative;
}

td input {
  outline: none;
  font-family: inherit;
  font-size: 100%;
  width: 80%;
  margin: 0;
  padding: 0;
  border: none;
  color: var(--color-text-primary);
  background: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.button--gray {
  font-family: inherit;
  /* font-size: 12px; */
  position: absolute;
  right: 0;
  width: 38px;
  margin: 0;
  padding: 4px;
  border: none;
  border-radius: 4px;
  color: var(--color-text-primary);
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;
}

.button--gray:hover {
  color: var(--color-accent-primary);
  background-color: var(--color-bg-secondary-light);
}

.raw-data-string {
  padding-top: 24px;
}

.raw-data-container {
  display: flex;
  flex-flow: column nowrap;
  gap: 16px;
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
  background-color: var(--color-bg-secondary-dark);
  border: 1px solid var(--color-border);
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}

.raw-data-wrapper {
  max-height: 200px;
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
}

.raw-data-wrapper--unfolded {
  max-height: unset;
}

.raw-data-wrapper--ellipsis {
  position: relative;
}

.raw-data-wrapper--ellipsis::after {
  content: "...";
  position: absolute;
  line-height: 0;
  bottom: 24px;
  left: 40px;
  background: linear-gradient(to right, transparent, #1a1a1a 50%);
  color: #e6e6e6;
  pointer-events: none;
}

.raw-json-wrapper {
  position: relative;
  max-height: 166px;
  margin-bottom: 16px;
  overflow: hidden;
  padding: 12px;
  background-color: #1a1a1a;
  width: 100%;
  box-sizing: border-box;
}

.raw-json-wrapper--unfolded {
  max-height: unset;
}

.raw-json {
  color: #e6e6e6;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  overflow-wrap: break-word;
  margin: 0;
  margin-bottom: 16px;
  overflow: hidden;
  max-height: 142px;
}

.raw-json--unfolded {
  max-height: unset;
  white-space: pre-wrap;
  word-break: break-all;
}

.raw-json::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.raw-json::-webkit-scrollbar-track {
  background: #2a2a2a;
}

.raw-json::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.raw-json::-webkit-scrollbar-thumb:hover {
  background: #777;
}

.button--show-more {
  position: relative;
  width: fit-content;
  padding: 4px 8px;
}

.json-copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  font-family: inherit;
  font-size: 10px;
  width: 32px;
  height: 20px;
  margin: 0;
  padding: 2px 4px;
  border: none;
  border-radius: 3px;
  color: var(--color-text-primary);
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
}

.json-copy-btn:hover {
  color: var(--color-accent-primary);
  background-color: var(--color-bg-secondary-light);
}

@media (max-width: 768px) {
  .layout {
    padding: 0 8px 48px;
  }

  .raw-data-container {
    padding: 12px;
    gap: 12px;
  }

  .raw-data-wrapper {
    padding: 12px;
  }

  .raw-json-wrapper {
    padding: 8px;
  }

  .raw-json {
    font-size: 11px;
  }

  td input {
    font-size: 14px;
  }
}
</style>
